export enum EditorMode {
  TrainingDay = "trainingDay",
  RestDay = "restDay",
}
